import axios from 'axios'

const axiosJWT = axios.create({ withCredentials: true })

let accessToken = null

// Fungsi helper buat fetch token
const fetchNewToken = async () => {
    try {
        const { data } = await axios.get('/api/pelaku-usaha/token', { withCredentials: true })
        accessToken = data.authToken

        localStorage.setItem("isLoggedIn", "true")

        return accessToken
    } catch (e) {
        localStorage.removeItem("isLoggedIn")
        return null
    }
}

// 1. Request Interceptor: Pastikan token ada sebelum request dikirim
axiosJWT.interceptors.request.use(async (config) => {
    if (!accessToken) {
        await fetchNewToken()
    }
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
        // console.log("=== SEDANG MENGIRIM REQUEST ===")
        // console.log("URL:", config.url)
        // console.log("Headers:", config.headers)
    }
    return config
})

// 2. Response Interceptor: Kalau 401, coba ambil token baru SEKALI LAGI
axiosJWT.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config
        
        // Pastikan error punya response sebelum diakses statusnya
        const status = error.response ? error.response.status : null

        // KITA TAMBAHKAN 403 DI SINI karena backend lu ngirim 403 saat token expired
        // Kondisi: (status 401 ATAU 403) DAN belum pernah di-retry
        if ((status === 401 || status === 403) && !originalRequest._retry) {
            originalRequest._retry = true

            const newToken = await fetchNewToken()
            if (newToken) {
                originalRequest.headers['Authorization'] = 'Bearer ' + newToken
                return axiosJWT(originalRequest) // Retry request yang gagal
            } else {
                // Token refresh gagal, tendang ke halaman login
                window.location.href = '/'
            }
        }
        return Promise.reject(error)
    }
)

export const getUserData = () => {
    if (!accessToken) return null
    try {
        const base64Url = accessToken.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        return JSON.parse(jsonPayload)
    } catch (e) { return null }
}

export default axiosJWT